import { ActionType, getType } from 'typesafe-actions';

import * as Action from '../actions/ZopimAction';

const defaultState = {
  showZendesk: true,
};
export default function constant(
  state = defaultState,
  action: ActionType<typeof Action>
) {
  switch (action.type) {
    case getType(Action.toggleZopim):
      return { ...state, showZendesk: !state.showZendesk };
    default:
      return state;
  }
}
